import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    imports: [],
    templateUrl: './loading-spinner.component.html',
    styleUrl: './loading-spinner.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': 'baseClass',
        '[class.is-loading]': 'loading',
        '[attr.aria-hidden]': '!loading'
    }
})
export class LoadingSpinnerComponent {
  public readonly baseClass = 'app-loading-spinner';

  @Input()
  public loading: boolean = false;
}
